import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-success-banner',
  standalone: true,
  imports: [MatProgressBarModule, MatButtonModule, MatIconModule],
  templateUrl: './success-banner.component.html',
  styleUrl: './success-banner.component.scss',
})
export class SuccessBannerComponent {
  displayText: string = '';
  @Input()
  set SuccessMessage(value: string) {
    this.displayText = value;
  }
}
